module.exports = __webpack_public_path__ + "static/media/01_design_agd-gamme-baie-pao.16927134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-gamme-baie-pao.jpg
// module id = 24
// module chunks = 0